import React from "react"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors"
import SectionHeader from "../../SectionHeader/SectionHeader"
import "@fontsource/noto-sans-jp/500.css"
import "@fontsource/raleway/300-italic.css"
import TestimoinialIcon from "../../../images/iconmonstr-speech-bubble-6--outline.svg"
import useFacilityData from "../../../hooks/useFacilityData.ts"

const HomeTestimonialsStyles = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 130px;
`

const TestimonialListWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
  @media screen and (min-width: 1024px) {
    flex-direction: row;
  }
`

const TestimonialStyles = styled.div`
  text-align: center;
  width: 100%;
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: 75px;
  @media screen and (min-width: 1500px) {
    width: 355px;
  }
  @media screen and (min-width: 1024px) {
    width: 250px;
    &:nth-last-child(-n + 5) {
      margin-bottom: 0;
    }
  }
`

const TestimonialDiv = styled.div`
  width: 1px;
  align-self: stretch;
  background-color: ${colors("blue")};
`

const TestimonialDecoration = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
`

const TestimonialIcon = styled(TestimoinialIcon)`
  color: ${colors("purple")};
  height: 41px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

const TestimonialNameLine = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 3px;
  width: 195px;
  background-color: ${colors("grey", "xlt")};
`

const TestimonialName = styled.p`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 17px;
  font-weight: 500;
  margin: 0 0 17px;
  color: ${colors("blue")};
`

const TestimonialContent = styled.p`
  font-size: 23px;
  font-weight: 300;
  font-style: italic;
  line-height: 35px;
  margin: 0;
`

const HomeTestimonials = () => {
  const pageData = useFacilityData()

  const testimonialArr = pageData.sanityFacility.facilityObj.testimonials

  const testimonialList = testimonialArr.map((testimonial, index) => {
    return (
      <React.Fragment key={testimonial._key}>
        <TestimonialStyles>
          <TestimonialDecoration>
            <TestimonialNameLine />
            <TestimonialIcon />
          </TestimonialDecoration>
          <TestimonialName>{testimonial.name}</TestimonialName>
          <TestimonialContent>{testimonial.content}</TestimonialContent>
        </TestimonialStyles>
        {(index + 1) % 3 !== 0 && <TestimonialDiv />}
      </React.Fragment>
    )
  })

  return (
    <HomeTestimonialsStyles role="region">
      <SectionHeader>Testimonials</SectionHeader>
      <TestimonialListWrap>{testimonialList}</TestimonialListWrap>
    </HomeTestimonialsStyles>
  )
}

export default HomeTestimonials
